<div class="content-container">
  <mat-toolbar class="sticky-toolbar">
    <h2>Home</h2>
    <span class="spacer"></span>
    <button mat-mini-fab [matMenuTriggerFor]="dashboardActions" id="home-actions-button" matTooltip="More options">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #dashboardActions="matMenu">
      <button mat-menu-item id="home-refresh-button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </mat-menu>
  </mat-toolbar>

  <div class="sub-content-container">
    <div class="container-fluid pd-20">
      <div class="row no-gutters">
        <div class="col-12">
          <div class="display-flex flex-row flex-wrap flex-gap-10">
            <mat-card
              *ngFor="let item of visibleQuickLinks"
              [id]="item.id"
              class="quick-link-card max-h-px-250 max-w-px-250 min-h-px-250 min-w-px-250 flex-item pointer"
              [routerLink]="item.route"
              [queryParams]="item.queryParams">
              <mat-card-header>
                <mat-card-title>{{ item.title }}</mat-card-title>
                <div class="spacer"></div>
                <div class="flex-shrink-0">
                  <mat-icon>{{ item.icon }}</mat-icon>
                </div>
              </mat-card-header>
              <mat-card-content>
                <mat-divider></mat-divider>
                {{ item.description }}
              </mat-card-content>
            </mat-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
